import * as React from 'react'
import { showErrorToast } from '@/components/ui/custom-toasts'
import { getTemplates } from '@/actions/templates/get-templates'
import { useAccountMatterStore } from '@/lib/store/use-account-matter-store';
import { useFeatureFlagsStore } from '@/lib/store/use-feature-flags-store';
import { usePromptTemplatesStore } from '@/lib/store/use-prompt-templates-store';

export function useFetchPromptTemplatesOnMatterChange() {
  const matter = useAccountMatterStore((store) => store.matter)
  const accountId = useAccountMatterStore((store) => store.accountId)
  const setIsLoadingGetTemplates = usePromptTemplatesStore((store) => store.setIsLoadingGetTemplates);
  const isPromptTemplatesAccessEnabled = useFeatureFlagsStore((state) => !!state['archie-templates-access'])
  const setPromptTemplates = usePromptTemplatesStore((store) => store.setPromptTemplates);
  const setMatterTypeFilter = usePromptTemplatesStore((store) => store.setMatterTypeFilter);

  React.useEffect(() => {
    // Fetch templates when we have an accountId (either with a matter or on home page)
    if (accountId && isPromptTemplatesAccessEnabled) {
      const fetchPromptTemplates = async () => {
        setIsLoadingGetTemplates(true)
        try {
          const templatesData = await getTemplates({ 
            matterTypeId: matter?.matterTypeId 
          })
          if (!templatesData || !templatesData.data) {
            console.error('Error fetching prompt templates:', templatesData)
            if (isPromptTemplatesAccessEnabled) {
              showErrorToast(`Something went wrong getting prompts from your library, if you need to use the prompt library please click the refresh button.`)
            }
          }
          setPromptTemplates(templatesData?.data || [])
          // Set the filter to match the fetched data to prevent unnecessary refetches
          setMatterTypeFilter(matter?.matterTypeId || null)
        } finally {
          setIsLoadingGetTemplates(false)
        }
      }
      fetchPromptTemplates()
    }
  }, [accountId, isPromptTemplatesAccessEnabled, matter?.matterTypeId, setIsLoadingGetTemplates, setPromptTemplates, setMatterTypeFilter])
}
